<script setup lang="ts">
import {RouterLink} from "vue-router";
import {AdminPages, Model} from "@/app/Model";
let model: Model = Model.getReactiveInstance();
</script>

<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb p-3 bg-body-tertiary rounded-2 breadcumb-admin">
      <li class="breadcrumb-item">
        <RouterLink to="/"><i class="bi bi-house-door-fill"></i>
          <span class="visually-hidden">Home</span></RouterLink>
      </li>
      <li class="breadcrumb-item">
        <a class="link-body-emphasis fw-semibold text-decoration-none" href="/admin">Admin</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page" v-if="model.adminPage == AdminPages.Home">
        Home
      </li>
      <li class="breadcrumb-item active" aria-current="page"  v-if="model.adminPage == AdminPages.Penale_Penale">
        Penale
      </li>
      <li class="breadcrumb-item active" aria-current="page"  v-if="model.adminPage == AdminPages.Penale_ReatoRubrica">
        Reato Rubrica
      </li>
      <li class="breadcrumb-item active" aria-current="page"  v-if="model.adminPage == AdminPages.Famiglia_Famiglia">
        Famiglia
      </li>
      <li class="breadcrumb-item active" aria-current="page"  v-if="model.adminPage == AdminPages.Responsabilita_Responsabilita">
        Responsabilita
      </li>
    </ol>
  </nav>
</template>
